import { render, staticRenderFns } from "./RELHistoricoEquipamento.vue?vue&type=template&id=2e82393c&scoped=true&"
import script from "./RELHistoricoEquipamento.vue?vue&type=script&lang=js&"
export * from "./RELHistoricoEquipamento.vue?vue&type=script&lang=js&"
import style0 from "./RELHistoricoEquipamento.vue?vue&type=style&index=0&id=2e82393c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e82393c",
  null
  
)

export default component.exports